import { Timestamp as FirebaseTimestamp } from 'firebase/firestore';

// Define our own Timestamp interface for compatibility with both Firebase and mock data
export interface Timestamp {
    toDate(): Date;
}

export interface AdVariation {
    id: string;
    image_url?: string;
    video_url?: string;
    start_time: string; // 24-hour format HH:mm
    end_time: string; // 24-hour format HH:mm
    start_date?: string; // YYYY-MM-DD format
    end_date?: string; // YYYY-MM-DD format
    name: string;
    description?: string;
    ad_type?: 'image' | 'video' | null; // Type of ad (image, video, or null for no media)
}

export interface Campaign {
    id?: string;
    category?: string;
    centre_name?: string;
    city?: string;
    country?: string;
    region?: string;
    target_link?: string;
    latitude?: number;
    longitude?: number;
    ad_variations: AdVariation[];
}

// Helper function to convert Firestore data to Campaign
export const convertToCampaign = (documentId: string, data: any): Campaign => {
    return {
        id: documentId,
        category: data.category,
        centre_name: data.centre_name,
        city: data.city,
        country: data.country,
        region: data.region,
        target_link: data.target_link,
        latitude: data.latitude,
        longitude: data.longitude,
        ad_variations: data.ad_variations
    };
}; 